/**
 * Copyright (c) 2026 ForgeRock. All rights reserved.
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useJourneyClientStore = defineStore('journeyClient', () => {
  const client = ref(null);

  function $reset() {
    client.value = null;
  }

  return {
    client,
    $reset,
  };
});
